import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import { BlogPost } from '../types';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard = ({ post }: BlogCardProps) => {
  return (
    <article className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-fast group">
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="relative h-48 overflow-hidden">
          <Image
            src={post.featuredImage}
            alt={post.featuredImageAlt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {post.isNew && (
            <div className="absolute top-3 right-3">
              <span className="inline-flex items-center space-x-1 bg-success text-success-foreground px-2.5 py-1 rounded-full text-xs font-semibold">
                <Icon name="Sparkles" className="w-3 h-3" />
                <span>New</span>
              </span>
            </div>
          )}
        </div>

        <div className="p-6">
          <div className="flex items-center space-x-3 mb-3">
            <span 
              className="px-2.5 py-1 rounded-full text-xs font-semibold"
              style={{ 
                backgroundColor: `${post.category.color}20`,
                color: post.category.color 
              }}
            >
              {post.category.name}
            </span>
            <div className="flex items-center space-x-1.5 text-xs text-text-secondary">
              <Icon name="Clock" className="w-3 h-3" />
              <span>{post.readTime} min</span>
            </div>
          </div>

          <h3 className="text-xl font-bold text-text-primary mb-3 line-clamp-2 group-hover:text-primary transition-colors duration-fast">
            {post.title}
          </h3>

          <p className="text-sm text-text-secondary mb-4 line-clamp-2">
            {post.excerpt}
          </p>

          <div className="flex items-center justify-between pt-4 border-t border-border">
            <div className="flex items-center space-x-2">
              <Image
                src={post.author.avatar}
                alt={post.author.avatarAlt}
                className="w-8 h-8 rounded-full object-cover"
              />
              <div>
                <p className="text-xs font-medium text-text-primary">{post.author.name}</p>
                <p className="text-xs text-text-secondary">
                  {post.publishedAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3 text-xs text-text-secondary">
              <div className="flex items-center space-x-1">
                <Icon name="Eye" className="w-3.5 h-3.5" />
                <span>{post.views > 1000 ? `${(post.views / 1000).toFixed(1)}k` : post.views}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Heart" className="w-3.5 h-3.5" />
                <span>{post.likes}</span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;